import type { Ref } from 'react';
import { forwardRef } from 'react';

import type { TIconSize } from '../../icon.interface';
const BillingConnectionErrorIcon = forwardRef(
  ({ ...props }: TIconSize, ref: Ref<SVGSVGElement>) => {
    return (
      <svg
        width="251"
        height="200"
        viewBox="0 0 251 200"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={ref}
        {...props}
      >
        <path
          d="M189.185 33.2679C197.055 46.3102 191.518 68.8525 192.047 87.9606C192.576 107.069 199.156 122.714 195.461 135.492C191.766 148.27 177.764 158.182 163.681 159.767C149.597 161.352 135.516 154.646 116.385 151.889C97.2532 149.132 73.0452 150.466 60.3913 139.677C47.7373 128.888 46.6232 106.053 55.133 89.6563C63.6429 73.2596 81.791 63.2247 97.3441 51.5595C112.897 39.8943 125.924 26.4452 143.02 21.5088C160.116 16.5724 181.351 20.1886 189.185 33.2679Z"
          fill="#E8F0FF"
        />
        <path
          d="M162.666 113.534C162.641 114.851 159.048 141.397 159.048 141.397L154.907 144.478H169.38C169.38 144.478 172.131 131.735 181.585 122.38C182.125 120.957 174.01 114.644 174.01 114.644L162.666 113.534Z"
          fill="#DB9D76"
        />
        <path
          d="M220.059 151.061C198.127 144.148 171.608 138.95 146.6 144.85C134.733 147.649 123.188 152.953 112.624 161.785L112.986 160.074C123.384 151.659 134.704 146.534 146.35 143.787C171.645 137.819 198.393 143.087 220.387 150.02L220.059 151.061Z"
          fill="#0B0B0B"
        />
        <path
          d="M230.148 142.819C230.083 142.539 229.814 142.357 229.532 142.41C225.487 143.178 219.15 145.63 219.506 150.584C220.035 157.953 228.304 156.782 232.664 156.535C233.008 156.516 233.253 156.192 233.175 155.856L232.228 151.778L231.13 147.05L230.148 142.819Z"
          fill="#0B0B0B"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M232.512 155.889C232.202 155.907 231.877 155.929 231.541 155.951C229.463 156.092 226.96 156.261 224.79 155.777C223.526 155.495 222.436 155.001 221.635 154.196C220.844 153.401 220.28 152.248 220.158 150.538C220.004 148.401 221.274 146.743 223.224 145.476C225.135 144.235 227.581 143.458 229.537 143.075L232.512 155.889ZM232.701 157.188C233.445 157.146 233.982 156.444 233.812 155.708L230.785 142.671C230.643 142.063 230.049 141.646 229.41 141.768C227.34 142.161 224.655 142.988 222.513 144.379C220.373 145.769 218.652 147.814 218.854 150.631C218.996 152.605 219.664 154.069 220.709 155.119C221.744 156.159 223.093 156.738 224.506 157.054C226.88 157.583 229.61 157.396 231.675 157.254C232.04 157.229 232.383 157.206 232.701 157.188Z"
          fill="#0B0B0B"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M232.761 168.261C233.12 168.297 233.44 168.035 233.477 167.676L234.259 159.896C234.295 159.537 234.034 159.216 233.675 159.18C233.316 159.144 232.995 159.406 232.959 159.765L232.176 167.545C232.14 167.904 232.402 168.225 232.761 168.261Z"
          fill="#ED9F38"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M245.639 158.271C245.872 157.996 245.839 157.583 245.564 157.349L239.067 151.815C238.792 151.581 238.38 151.615 238.146 151.89C237.912 152.165 237.945 152.578 238.22 152.812L244.718 158.345C244.992 158.579 245.405 158.546 245.639 158.271Z"
          fill="#ED9F38"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M233.503 138.918C233.86 138.971 234.193 138.725 234.246 138.368L235.177 132.112C235.231 131.755 234.984 131.422 234.628 131.369C234.271 131.316 233.938 131.562 233.885 131.92L232.954 138.175C232.9 138.532 233.147 138.865 233.503 138.918Z"
          fill="#ED9F38"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M240.076 143.842C239.965 144.186 240.154 144.555 240.497 144.665L246.852 146.713C247.195 146.824 247.563 146.635 247.674 146.291C247.784 145.947 247.596 145.579 247.252 145.468L240.898 143.42C240.554 143.31 240.186 143.499 240.076 143.842Z"
          fill="#ED9F38"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M243.012 139.195C243.211 139.497 243.616 139.58 243.917 139.381L248.675 136.24C248.977 136.041 249.06 135.635 248.861 135.334C248.662 135.032 248.257 134.949 247.956 135.148L243.198 138.289C242.896 138.488 242.813 138.894 243.012 139.195Z"
          fill="#ED9F38"
        />
        <path
          d="M96.1765 104.464C93.6923 104.422 91.1494 104.4 88.5477 104.398C86.6633 104.398 84.8527 104.609 84.8527 105.098C84.8527 105.588 87.7121 112.641 88.0617 112.988C88.4113 113.335 91.8988 113.787 91.8988 115.782C91.8988 116.761 91.5407 120.812 87.0839 120.812C81.2203 120.812 68.9443 100.722 68.9443 94.352C70.897 93.5838 86.9447 90.4314 86.9447 90.4314"
          fill="#DB9D76"
        />
        <path
          d="M123.722 105.977C178.294 111.335 193.893 129.086 193.893 139.966C193.893 140.859 189.587 143.804 189.587 144.478H205.458C205.743 143.625 206.595 136.227 206.595 127.692C206.595 101.451 182.7 74.2026 177.604 74.2026C175.898 74.2026 170.953 75.9097 155.718 75.9097C76.9605 75.9097 112.208 34.9392 83.2392 34.9392C73.8255 34.9392 68.661 47.1251 64.2668 47.1251C63.1498 47.1251 55.6148 45.7992 54.9156 45.7992C54.2164 45.7992 51.7891 46.8463 51.7891 49.1508C51.7891 67.0328 67.2569 67.9973 73.8368 72.1313C77.1396 74.2054 84.9218 87.427 86.9541 90.4201C89.7708 94.9724 119.7 141.59 119.7 141.59L115.437 144.478H133.287L123.722 105.977Z"
          fill="#FFB688"
        />
        <path
          d="M84.8954 42.6633C86.8082 42.0687 97.555 41.6078 102.634 44.0489C102.634 54.2916 99.9681 68.2699 91.3588 67.3537C83.9063 66.5599 80.0151 54.5448 84.8954 42.6633Z"
          fill="#0B0B0B"
        />
        <path
          d="M66.6279 60.3805C67.4806 61.9425 74.2794 71.7982 78.8157 70.0541C81.8599 68.8819 77.963 59.5725 76.2093 57.4272C75.1122 58.0134 69.7118 60.0761 66.6279 60.3805Z"
          fill="#FFB688"
        />
        <path
          d="M72.0786 59.1572C72.5362 59.9709 73.244 61.2598 74.4093 62.9726"
          stroke="#FFB688"
          strokeWidth="0.294964"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M52.4336 55.0149C55.6283 60.5345 64.1757 58.7862 66.2947 57.8771"
          stroke="#4D4D4D"
          strokeWidth="0.589929"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M55.4936 47.114C56.7573 47.114 57.7817 46.6542 57.7817 46.0869C57.7817 45.5197 56.7573 45.0598 55.4936 45.0598C54.23 45.0598 53.2056 45.5197 53.2056 46.0869C53.2056 46.6542 54.23 47.114 55.4936 47.114Z"
          fill="#4D4D4D"
        />
        <path
          d="M74.6887 47.111C75.3245 47.111 75.8399 46.1352 75.8399 44.9316C75.8399 43.7279 75.3245 42.7522 74.6887 42.7522C74.053 42.7522 73.5376 43.7279 73.5376 44.9316C73.5376 46.1352 74.053 47.111 74.6887 47.111Z"
          fill="#4D4D4D"
        />
        <path
          d="M185.05 82.6499C193.216 82.6499 202.459 68.8309 202.459 62.0395C202.459 48.0669 189.737 42.9456 185.428 42.9456C175.764 42.9456 173.32 52.5708 173.32 53.4727C173.32 54.3746 173.715 55.6379 173.931 55.6379C174.147 55.6379 175.463 54.9579 176.361 54.9579C184.698 54.9579 185.488 61.2998 185.488 62.3126C185.488 70.5836 177.566 74.655 176.236 74.655C174.906 74.655 181.864 82.6499 185.05 82.6499Z"
          fill="#FFB688"
        />
        <path
          d="M81.0474 81.2073C84.2933 80.146 98.8857 73.3945 106.128 63.2827"
          stroke="#065BDC"
          strokeWidth="2.06475"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M51.7329 55.2871C53.2723 56.1769 55.2171 58.0015 57.3109 61.4706C58.5824 63.5774 59.3225 66.4666 59.9071 69.9557C60.1983 71.6938 60.4485 73.5639 60.7096 75.5425L60.7587 75.9148C61.0045 77.7794 61.2623 79.7353 61.5737 81.7504C62.9022 90.3492 65.213 100.091 71.826 108.86C82.546 123.075 91.8827 130.859 100.451 135.062C109.027 139.27 116.784 139.866 124.281 139.792C126.03 139.775 127.759 139.722 129.479 139.669L129.479 139.669L129.479 139.669C135.156 139.495 140.729 139.324 146.555 140.454C154.106 141.919 162.079 145.579 171.084 154.349C171.57 154.517 172.039 153.953 171.823 153.588C162.684 144.688 154.529 140.92 146.757 139.412C140.803 138.257 135.072 138.434 129.372 138.609L129.37 138.609C127.669 138.662 125.971 138.714 124.271 138.731C116.848 138.804 109.28 138.213 100.917 134.109C92.5462 130.002 83.3296 122.352 72.6721 108.221C66.2182 99.663 63.9411 90.1308 62.6213 81.5882C62.312 79.5865 62.0558 77.6428 61.8098 75.7773L61.8096 75.7753L61.7606 75.4036C61.4998 73.4272 61.2473 71.5393 60.9526 69.7802C60.3653 66.275 59.6011 63.213 58.2183 60.9219C56.0651 57.3543 54.0047 55.3748 52.263 54.3681C50.532 53.3676 49.0708 53.3089 48.1903 53.6959C47.9222 53.8138 47.8004 54.1268 47.9181 54.3951C48.0357 54.6634 48.3485 54.7854 48.6165 54.6676C49.0868 54.4608 50.1828 54.3911 51.7329 55.2871Z"
          fill="#0B0B0B"
        />
        <path
          d="M32.1742 63.1081C32.4167 64.6753 33.8353 65.7991 35.3922 65.5052C40.643 64.5138 47.2199 61.8111 47.2369 56.0801C47.2616 47.7725 39.2603 47.0894 33.3435 47.0015C31.4446 46.9732 29.9447 48.7006 30.2354 50.5792L30.6505 53.2617L31.6279 59.5775L32.1742 63.1081Z"
          fill="#0B0B0B"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.7856 54.0372C21.829 54.5335 22.2659 54.9006 22.7617 54.8572L29.8885 54.2336L30.5893 58.7628L23.582 59.3753C23.0863 59.4187 22.7195 59.8561 22.7628 60.3523C22.8061 60.8485 23.2431 61.2156 23.7388 61.1723L30.8658 60.5493L31.2831 63.2461C31.5945 65.2586 33.445 66.7904 35.5584 66.3914C38.2444 65.8843 41.3305 64.9306 43.7716 63.3235C46.2259 61.7077 48.1274 59.3546 48.1372 56.0827C48.1438 53.8553 47.6103 52.0696 46.6525 50.6615C45.6976 49.2575 44.3661 48.2952 42.8841 47.6345C39.9591 46.3304 36.3064 46.1435 33.3561 46.0996C30.8987 46.0631 28.9683 48.2872 29.3443 50.7172L29.612 52.4471L22.6048 53.0602C22.109 53.1036 21.7423 53.541 21.7856 54.0372ZM31.1251 50.4411C30.9197 49.1139 31.989 47.8833 33.3294 47.9032C36.2959 47.9473 39.6023 48.1459 42.1509 49.2822C43.4057 49.8417 44.4398 50.6134 45.163 51.6767C45.8835 52.7359 46.3409 54.151 46.3352 56.0773C46.3279 58.5365 44.9325 60.4002 42.7814 61.8164C40.6171 63.2413 37.7894 64.1346 35.2245 64.6188C34.224 64.8077 33.2375 64.092 33.0638 62.97L31.1251 50.4411Z"
          fill="#0B0B0B"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.1059 38.6339C16.7551 38.7186 16.5391 39.0718 16.6235 39.423L18.4505 47.0243C18.5349 47.3754 18.8878 47.5915 19.2386 47.5068C19.5894 47.4221 19.8053 47.0689 19.7209 46.7177L17.8939 39.1164C17.8095 38.7653 17.4567 38.5493 17.1059 38.6339Z"
          fill="#FFCA70"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.17428 61.8365C7.29297 62.1776 7.66542 62.3577 8.00616 62.2389L15.3826 59.667C15.7234 59.5482 15.9034 59.1753 15.7847 58.8343C15.666 58.4932 15.2936 58.313 14.9528 58.4318L7.57635 61.0037C7.23561 61.1226 7.0556 61.4954 7.17428 61.8365Z"
          fill="#FFCA70"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.94808 47.4982C5.81818 47.8351 5.98577 48.2137 6.3224 48.3437L14.2812 51.4179C14.6178 51.5479 14.996 51.3801 15.1259 51.0432C15.2558 50.7062 15.0882 50.3276 14.7516 50.1976L6.7928 47.1234C6.45617 46.9934 6.07797 47.1612 5.94808 47.4982Z"
          fill="#FFCA70"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.0898 66.5742C25.7354 66.6419 25.503 66.9844 25.5707 67.3392L26.7559 73.5512C26.8236 73.906 27.1658 74.1386 27.5202 74.0709C27.8746 74.0031 28.1071 73.6606 28.0394 73.3058L26.8541 67.0938C26.7865 66.7391 26.4443 66.5064 26.0898 66.5742Z"
          fill="#FFCA70"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.3931 64.3796C19.1061 64.1607 18.6961 64.2162 18.4775 64.5035L15.0231 69.0422C14.8045 69.3295 14.8599 69.7398 15.1469 69.9587C15.4339 70.1776 15.8439 70.1221 16.0625 69.8348L19.5169 65.2962C19.7355 65.0089 19.6801 64.5985 19.3931 64.3796Z"
          fill="#FFCA70"
        />
      </svg>
    );
  }
);
export default BillingConnectionErrorIcon;
